import React from "react";
import { connect } from "react-redux";

import { setRowDeleted, setRowUndeleted } from "../../../core/actions/editing";
import { EditableCellWrapper } from "../cell/editableCellWrapper";


const _EditableRow = ({ dispatch, fields, rowKey, canDeleteRows, deletedRowKeys, addedRows }) => {

    const isDeleted = deletedRowKeys.includes(rowKey);

    return (
        <tr>
            { fields.map((field) => (
                <EditableCellWrapper
                    key={ rowKey + '.' + field.name }
                    rowKey={ rowKey }
                    field={ field }
                    isDeleted={ isDeleted }
                />
            ))}
            { ( canDeleteRows || Object.keys(addedRows).includes(rowKey) ) ?
                <td className="register-table--delete-cell u-text-center">
                    <div className="u-height-100">
                        { isDeleted ?
                            <button className="cursor-pointer u-m-reset u-p--reset button-reset u-height-100" onClick={ () => dispatch( setRowUndeleted(rowKey) )}>
                                <b>Undo</b>
                            </button>
                            :
                            <button className="cursor-pointer u-m-reset u-p--reset button-reset u-pos-relative u-height-100" onClick={ () => dispatch( setRowDeleted(rowKey) )}>
                                <svg className="icon-delete" style={{ width: '20px', height: '20px' }}>
                                    <use xlinkHref="#icon-delete"></use>
                                </svg>
                            </button>
                        }
                    </div>
                </td>
                :
                <td></td>
            }
        </tr>
    );
};

const mapStateToProps = (state) => ({
    fields: state.immutableBaseData.fields,
    fieldWidths: state.immutableBaseData.fieldWidths,
    canDeleteRows: state.immutableEditing.canDeleteRows,
    deletedRowKeys: state.mutableEditing.deletedRowKeys,
    addedRows: state.mutableEditing.addedRows,
});

export const EditableRow = connect(mapStateToProps)(_EditableRow);
